import React from 'react'
import { Field, ErrorMessage } from 'formik'

const Radio = (props) => {
    const {label, name, options, ...rest } = props
    return (
        <div className="form-control">
            <label>{label}</label>
            <Field id={name} name={name} {...rest}>
                {({ field }) => {
                    return options.map(option => {
                        return (
                            <React.Fragment key={option.key}>
                                <input type="radio"
                                id={option.value}
                                {...field}
                                value={option.value}
                                checked={field.value === option.value} />
                            </React.Fragment>
                        )
                    })
                }}
            </Field>
            <ErrorMessage name={name} className='error' />
        </div>
    )
}

export default Radio
